import { gql } from '@apollo/client';

export const getClaimsList = gql`
  query getClaimsList(
    $pagination: PaginationInput!
    $selectedLines: [String!]
    $selectedSublines: [String!]
    $selectedPlans: [String!]
    $companies: [String!]
    $insureds: [String!]
    $SelectedStatuses: [String!]
    $claimDateStart: DateTime
    $claimDateEnd: DateTime
    $declarationDateStart: DateTime
    $declarationDateEnd: DateTime
    $KeywordSearch: String
    $OrderBy: OrderByInput
  ) {
    claimManagement {
      getClaimsList(
        keyword: $KeywordSearch
        orderBy: $OrderBy
        pagination: $pagination
        statuses: $SelectedStatuses
        lines: $selectedLines
        sublines: $selectedSublines
        plans: $selectedPlans
        companies: $companies
        insureds: $insureds
        claimDateStart: $claimDateStart
        claimDateEnd: $claimDateEnd
        declarationDateStart: $declarationDateStart
        declarationDateEnd: $declarationDateEnd
      ) {
        paging {
          pageNumber
          pageSize
          totalCount
        }
        items {
          id
          claimNumber
          claimDate
          declarationDate
          policyId
          status
          statusReason
          line {
            id
            code
            name
          }
          subline {
            id
            code
            name
          }
          plan {
            id
            code
            name
          }
          policy {
            id
            policyNumber
          }
          insured {
            id
            firstName
            middleName
            lastName
          }
        }
      }
    }
  }
`;

export const getClaimLovFilters = gql`
  query getClaimLovFilters($selectedLineIds: [String!]) {
    claimManagement {
      getClaimsLovs(selectedLineIds: $selectedLineIds) {
        claimStatuses {
          id
          value
        }
        companies {
          id
          value
        }
        plans {
          id
          value
        }
        insureds {
          id
          ids
          value
        }
        sublines {
          id
          value
        }
        lines {
          id
          value
        }
      }
    }
  }
`;

export const getPoliciesForClaimLov = gql`
  query getPoliciesForClaimLov(
    $pagination: PaginationInput!
    $keyword: String
  ) {
    production {
      searchPolicies(
        pagination: $pagination
        keyword: $keyword
        statuses: ["Inforce", "InProgress", "Expired"]
      ) {
        items {
          id
          policyNumber
          policyEffectiveDate
          policyExpiryDate
        }
        paging {
          totalCount
        }
      }
    }
  }
`;

export const getPolicyPolicyPersons = gql`
  query getPolicyPolicyPersons($policyID: String!) {
    production {
      getPolicyPolicyPersons(policyID: $policyID) {
        firstName
        middleName
        lastName
        id
        typeList
      }
    }
  }
`;

export const getClaimDetails = gql`
  query getClaimDetails($id: String!) {
    claimManagement {
      getClaimDetailsById(id: $id) {
        claimCoverDetails {
          id
          estimation
          estimationDate
          paidAmount
          paidDate
          paidAmountClaim
          approvedAmount
          approvedAmountClaim
          approvalDate
          policyPlanCoverId
          estimationCurrencyId
          estimationCurrency {
            id
            code
            title
          }
          estimationClaim
          claim {
            id
            insuredId
            policyId
            claimDate
            declarationDate
            status
            statusReason
            insured {
              firstName
              middleName
              lastName
            }
            policy {
              policyCurrency {
                id
                symbol
                title
              }
            }
          }
          policyPlanCoverId
          policyPlanCover {
            coverID
            cover {
              id
              code
              name
            }
            policyID
            sumInsured
          }
          claimCoverId
          claimCover {
            id
            code
            name
            coverID
          }
        }

        claimDetails {
          declarationDate
          claimDate
          insured
          claimNotes
          claimCurrency {
            symbol
          }
        }

        claimSummary {
          policyId
          lineId
          sublineId
          planId
          policyEffectiveDate
          status
          claimNumber
          policyNumber
          policyEffectiveDate
          policyExpiryDate
          lines
          subline
          plan
          relatedCompany
          status
          statusReason
          createdBy
          createdDate
          modifiedBy
          modifiedDate
        }

        documents {
          documentId
          documentName
          documentPath
          documentType
          documentCreatedOn
          documentVersion
        }
      }
    }
  }
`;

export const getPolicyPolicyPlanCoversByPolicyId = gql`
  query getPolicyPolicyPlanCovers($policyId: String!) {
    production {
      getPolicyPolicyPlanCovers(policyID: $policyId) {
        id
        policyID
        coverID
        cover {
          id
          code
          name
        }
        sumInsured
      }
    }
  }
`;

export const getClaimCovers = gql`
  query getClaimCovers($pageNumber: Int!, $pageSize: Int!, $coverID: String!) {
    planConfig {
      getCoverClaimCovers(
        coverID: $coverID
        pagination: { pageNumber: $pageNumber, pageSize: $pageSize }
      ) {
        items {
          id
          coverID
          code
          name
        }
      }
    }
  }
`;
